import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "25",
  height: "24",
  viewBox: "0 0 25 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M20.75 11.0859H4.25V22.0859H20.75V11.0859Z",
      stroke: "white",
      "stroke-width": "1.5",
      "stroke-linejoin": "round"
    }, null, -1),
    _createElementVNode("path", {
      d: "M12.5 14.75V18.4167",
      stroke: "white",
      "stroke-width": "1.5",
      "stroke-linecap": "round"
    }, null, -1),
    _createElementVNode("path", {
      d: "M16.3307 6.5013C16.3307 6.91552 16.6665 7.2513 17.0807 7.2513C17.4949 7.2513 17.8307 6.91552 17.8307 6.5013H16.3307ZM8.66406 11.0846V6.5013H7.16406V11.0846H8.66406ZM8.66406 6.5013C8.66406 4.38421 10.3803 2.66797 12.4974 2.66797V1.16797C9.55188 1.16797 7.16406 3.55579 7.16406 6.5013H8.66406ZM12.4974 2.66797C14.6145 2.66797 16.3307 4.38422 16.3307 6.5013H17.8307C17.8307 3.55579 15.4429 1.16797 12.4974 1.16797V2.66797Z",
      fill: "white"
    }, null, -1)
  ])))
}
export default { render: render }